import useSWR from 'swr';
import { isDefined } from '@peloton/types';
import { getCookieValue } from '@engage/cookies';
import { defaultTTL } from '@engage/data-fetch-v2/lib/config';
import { ENVIRONMENT, isProdEnv } from '@webtv/env';
import { ExperimentManager } from './ExperimentManager';
export var isExperimentEnabled = function isExperimentEnabled(key) {
  var customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (typeof window === 'undefined') return false;
  var userId = ExperimentManager.getUserId();
  var attributes = ExperimentManager.getCombinedAttributes(customAttributes);

  if (!isProdEnv(ENVIRONMENT)) {
    // Check to see if cookie has been set in the QA config tool
    var cookieValue = getCookieValue(key); // If a cookie has been set, it will either be 'true' or 'false'. This should
    // take precedence over the optimizely value

    if (cookieValue) return cookieValue === 'true';
  }

  var client = ExperimentManager.getOptimizelyClient(); // If Optimizely is down, default to turning off the experiment

  if (!client) return false; // Check if feature is enabled in Optimizely based on userId, attributes/member groups, and audience settings in Optimizely
  // If you need a feature enabled, add it to the Features in WebTV Project on Optimizely (refer to Experiment ADR)

  return client.isFeatureEnabled(key, userId, attributes);
};
export var useIsExperimentEnabled = function useIsExperimentEnabled(key) {
  var customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useSWR = useSWR("experiment-".concat(key, "}"), function () {
    return isExperimentEnabled(key, customAttributes);
  }, {
    refreshInterval: defaultTTL
  }),
      isEnabled = _useSWR.data; // Even though experiment checks are instant, SWR will return undefined for a short duration while it initializes context
  // Using the fallBack data option, the optimizely SDK is called on _every_ render.


  if (!isDefined(isEnabled)) {
    return isExperimentEnabled(key, customAttributes);
  }

  return isEnabled;
};